// src/components/maintenance/MaintenanceOperationsEdit.js
import React from 'react';
import {
  Edit,
  useRecordContext,
  Loading,
  useGetOne,
} from 'react-admin';
import { Box, Divider, Alert } from '@mui/material';
import JobStatus from './components/JobStatus';
import PendingView from './components/PendingView';
import UploadedView from './components/UploadedView';
import ValidationView from './components/ValidationView';
import ProcessedView from './components/ProcessedView';
import FailedView from './components/FailedView';

const MaintenanceOperationsEditContent = () => {
  const record = useRecordContext();
  
  if (!record) {
    return (
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <Loading />
      </Box>
    );
  }
  
  return (
    <Box sx={{ p: 2 }}>
      <JobStatus />
      <Divider sx={{ my: 3 }} />
      
      {record.status === 'pending' && <PendingView />}
      {record.status === 'uploaded' && <UploadedView />}
      {record.status === 'validated' && <ValidationView />}
      {record.status === 'processed' && <ProcessedView />}
      {record.status === 'failed' && <FailedView />}
      
      {!['pending', 'uploaded', 'validated', 'processed', 'failed'].includes(record.status) && (
        <Alert severity="warning">
          Unknown status: {record.status}
        </Alert>
      )}
    </Box>
  );
};

const MaintenanceOperationsEdit = (props) => {
  return (
    <Edit 
      {...props} 
      title={<MaintenanceTitle />}
      mutationMode="pessimistic"
    >
      <MaintenanceOperationsEditContent />
    </Edit>
  );
};

const MaintenanceTitle = () => {
  const record = useRecordContext();
  return record ? `Maintenance Job #${record.id}` : 'Loading...';
};

export default MaintenanceOperationsEdit;